import i18n from 'utils/i18n'

export const createTimeslotKindTimeOptions = ({ past = true, present = true } = {}) => {
	const timeOptions = [{
		value: null,
		label: i18n.t(`management:form.no_limit` )
	}];
	
	const maxWeeks = 4;
	const maxDays = 13;
	const maxHours = 47;
	const minuteOptions = [ 45, 30, 15, 10, 5 ]
	
	if( past === true ) {
		for( let weeks = maxWeeks; weeks >= 2; weeks-- ) {
			timeOptions.push({
				value: `week:${weeks}:-`,
				label: i18n.t(`management:form.time_before_start_time.week`, {
					count: weeks
				} )
			});
		}
		
		for( let days = maxDays; days >= 0; days-- ) {
			timeOptions.push({
				value: `day:${days}:-`,
				label: i18n.t(`management:form.time_before_start_time.day`, {
					count: days
				} )
			});
		}
		
		for( let hours = maxHours; hours >= 1; hours-- ) {
			timeOptions.push({
				value: `hour:${hours}:-`,
				label: i18n.t(`management:form.time_before_start_time.hour`, {
					count: hours
				} )
			});
		}
		
		for( let minutes of minuteOptions ) {
			timeOptions.push({
				value: `minute:${minutes}:-`,
				label: i18n.t(`management:form.time_before_start_time.minute`, {
					count: minutes
				})
			});
		}
		
		timeOptions.push({
			value: `hour:0:-`,
			label: i18n.t(`management:form.time_before_start_time.at`,)
		});
	}
	
	if( present === true ) {
		for( let minutes of minuteOptions.reverse() ){
			timeOptions.push({
				value: `minute:${minutes}:+`,
				label: i18n.t(`management:form.time_after_start_time.minute`, {
					count: minutes
				})
			});
		}
		
		for( let hours = 1; hours <= 24; hours++ ) {
			timeOptions.push({
				value: `hour:${hours}:+`,
				label: i18n.t(`management:form.time_after_start_time.hour`, {
					count: hours
				})
			});
		}
	}
	
	return timeOptions;
}
